import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import Index from '@/views/Index';
import Auth from '@/views/Auth';
import Downloads from '@/views/Downloads';
import Kabinet from '@/views/Kabinet';
import NewPost from '@/views/NewPost';
import Post from '@/views/Post';
import Launcher from '@/views/Launcher';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Главная',
      component: Index,
    },
    {
      path: '/login',
      name: 'Авторизация',
      meta: {
        headless: true,
      },
      component: Auth,
    },
    {
      path: '/downloads',
      name: 'Загрузки',
      component: Downloads,
    },
    {
      path: '/lk',
      name: 'Личный кабинет',
      component: Kabinet,
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/new-post',
      name: 'Добавить новость',
      component: NewPost,
      meta: {
        authRequired: true,
        adminPage: true,
      },
    },
    {
      path: '/post/:uid',
      name: 'Post',
      component: Post,
    },
    {
      path: '/edit/:uid',
      name: 'Редактирование новости',
      props: {
        editing: true,
      },
      component: NewPost,
    },
    {
      path: '/admin/launcher',
      name: 'Управление Лаунчером',
      component: Launcher,
      meta: {
        adminPage: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const isAuth = store.getters.isAuth;
  const isAdmin = store.getters.admin;
  if (to.matched.some(route => route.meta.authRequired) && !isAuth) {
    next('/login');
  } else {
    next();
  }
  if (to.matched.some(route => route.meta.adminPage) && !isAdmin) {
    next('/');
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js